/* panel-body.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i5ze3t%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q51v47k%7Bpadding-block-start%3Avar(--ds-space-250%2C20px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1ejb%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1ejb%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1i4qfg65%7Boverflow-wrap%3Aanywhere%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
import type { ReactNode } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
export interface PanelBodyProps {
  /**
   * The content of the panel body.
   */
  children: ReactNode;
  /**
   * Controls the padding of the panel body.
   */
  spacing?: 'none' | 'default';
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}
const styles = {
  body: "_1reo1wug _18m91wug _16jlkb7n _1i4qfg65",
  defaultSpacing: "_bozg1ejb _y4ti1ejb _1q51v47k _85i5ze3t"
};

/**
 * The PanelBody component provides the main content area for panels
 * with consistent styling and scroll behavior.
 */
export function PanelBody({
  children,
  spacing = 'default',
  testId
}: PanelBodyProps): JSX.Element {
  return <Box testId={testId} xcss={cx(styles.body, spacing === 'default' && styles.defaultSpacing)}>
			{children}
		</Box>;
}